module.exports = __webpack_public_path__ + "static/media/dec-bank-statement@2x.4356c124.png";